var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "collection-promo-tile",
      attrs: { href: _vm.promoTile.url ? _vm.promoTile.url : "" }
    },
    [
      _c("img", {
        staticClass: "collection-promo-tile__image",
        attrs: { src: _vm.promoTile.imageUrl }
      }),
      _c("div", { staticClass: "collection-promo-tile__text" }, [
        _vm.promoTile.title
          ? _c("h3", [_vm._v(_vm._s(_vm.promoTile.title))])
          : _vm._e(),
        _vm.promoTile.copy
          ? _c("a", [_vm._v(_vm._s(_vm.promoTile.copy))])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }